import { Model } from '@vuex-orm/core'
import { BrazeWebhookDto } from './braze-webhook.interface'
import { Constants } from '@/constants'

export default class BrazeWebhook extends Model {
    static entity = 'braze-webhooks'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async createOne(payload: BrazeWebhookDto) {
        return await this.api().post(Constants.API.BRAZE_WEBHOOK, payload)
    }

    static async findOne(id: number) {
        return await this.api().get(Constants.API.BRAZE_WEBHOOK + "/" + id)
    }

    static async updateOne(id: number, payload: BrazeWebhookDto) {
        return await this.api().patch(Constants.API.BRAZE_WEBHOOK + "/" + id, payload)
    }

    static async removeOne(id: number) {
        return await this.api().delete(Constants.API.BRAZE_WEBHOOK + "/" + id)
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/braze-webhooks'
            }
        }
    }
}
